//mixins
import FormShared from '@/mixins/forms/form-shared';
import PaginationPage from '@/mixins/infiniteScroll/page';
import DateTimeMixins from '@/mixins/datetime-mixin';

//vue store
import { HAS_ERROR } from '@/store/modules/mutation-types.js';
import { mapActions, mapGetters } from 'vuex';

//library
import _ from 'lodash';

//functions
import { deepEqual as objCompare } from '@/utils/object';

export default {
	mixins: [FormShared, PaginationPage, DateTimeMixins],
	props: {
		id: {
			type: Number
		},
		form: {
			type: Object,
			default: () => {}
		},
		customerParam: {
			type: Object
		}
	},
	data() {
		return {
			expiredTime: false,
			isAutoSaved: false,
			showModal: false,
			dataForm: {},
			originalForm: {},
			splitbuttonItems: [
				{
					text: 'Save',
					value: 1
				}
			],
			splitbuttonValue: {
				text: 'Save & Close',
				value: 0
			},
			splitOptionValue: null,
			toastCounter: 0,
			toastClassName: '',
			toastMessage: '',
			callTime: null,
			minutesAgo: 0,
			displayConfirmationModal: false,
			loaded: false,
			saveSuccessully: false,
			pdfFileDeleted: false,
			reloaded: false,
			displayFooter: false,
			maxHeightInfinityScroll: 0,
			extraHeightInfinityScroll: 0,
			mainScrollHeight: 0,
			scrollEnd: false,
			defaultUrlNamesCustomers: [
				{
					url: '/clients',
					name: 'Clients'
				},
				{
					url: `/clients/${this.$route.params.customerId}/forms`,
					name: 'Forms'
				}
			],
			defaultUrlNamesGlobalForms: [
				{
					url: `/forms`,
					name: 'Global Forms'
				}
			]
		};
	},
	beforeRouteEnter(to, from, next) {
		next(vm => {
			if (!vm.validatePermission('forms.update')) {
				next(to.path.replace('/edit', '/preview'));
			}
		});
	},
	async created() {
		const id = this.id;
		if (id > 0) {
			await this.getFormById(id);
		} else {
			const formPrintType = this.formType === 'Laser' ? 'L' : 'I';
			this.dataForm = {
				active: true,
				formPrintType: formPrintType,
				customers: [],
				impactInputFields: [],
				status: 'U',
				name: '',
				description: ''
			};
		}
	},
	computed: {
		...mapGetters('forms', ['resetValue', 'currentCustomers']),
		...mapGetters('form', [HAS_ERROR]),

		hasFormChanges() {
			if (this.saveSuccessully) return false;
			if (this.hasFormBuilderErrors) {
				return false;
			}
			if (this[HAS_ERROR]) {
				return false;
			}
			if (this.requireFieldsAreNotEmpty) {
				return !objCompare(this.dataForm, this.originalForm, true, [
					'active',
					'pdfData',
					'laserFormFileName',
					'minutesAgo',
					'status',
					'rowModifiedDate'
				]);
			} else {
				return false;
			}
		},
		hasFormBuilderErrors() {
			const { impactInputFields } = this.dataForm;
			if (impactInputFields) {
				const index = impactInputFields.findIndex(
					input =>
						Math.sign(input.row) === -1 ||
						Math.sign(input.dot) === -1 ||
						input.dot > 11 ||
						Math.sign(input.col) === -1
				);
				if (index !== -1) {
					return true;
				}
			}
			return false;
		},

		changesOnForm() {
			let changesMsg = '';

			if (this.minutesAgo === 0) {
				changesMsg = 'Modified now';
			} else if (this.minutesAgo < 60) {
				changesMsg =
					this.minutesAgo === 1
						? 'Modified minute ago'
						: `Modified ${this.minutesAgo} minutes ago`;
			} else if (this.minutesAgo >= 60 && this.minutesAgo < 1440) {
				let hours = Math.floor(this.minutesAgo / 60);
				let restofMinutes = Math.floor(this.minutesAgo % 60);

				if (restofMinutes === 0) {
					return (changesMsg =
						hours === 1
							? `Modified ${hours} hour ago`
							: `Modified ${hours} hours ago`);
				}
				if (hours === 1) {
					changesMsg =
						hours === 1 && restofMinutes === 1
							? `Modified ${hours} hour and ${restofMinutes} minute ago`
							: `Modified ${hours} hour and ${restofMinutes} minutes ago`;
				} else {
					changesMsg =
						restofMinutes === 1
							? `Modified ${hours} hours and ${restofMinutes} minute ago`
							: `Modified ${hours} hours and ${restofMinutes} minutes ago`;
				}
			} else if (this.minutesAgo >= 1440 && this.minutesAgo < 43800) {
				let days = Math.floor(this.minutesAgo / 1440);
				let restofHours = Math.floor(
					Math.floor(this.minutesAgo % 1440) / 60
				);

				if (restofHours === 0) {
					return (changesMsg =
						days === 1
							? `Modified ${days} day ago`
							: `Modified ${days} days ago`);
				}

				if (days === 1) {
					changesMsg =
						days === 1 && restofHours === 1
							? `Modified ${days} day and ${restofHours} hour ago`
							: `Modified ${days} day and ${restofHours} hours ago`;
				} else {
					changesMsg =
						restofHours === 1
							? `Modified ${days} days and ${restofHours} hour ago`
							: `Modified ${days} days and ${restofHours} hours ago`;
				}
			} else if (this.minutesAgo >= 43800 && this.minutesAgo < 525600) {
				let months = Math.floor(this.minutesAgo / 43800);
				let restofDays = Math.floor(
					Math.floor(this.minutesAgo % 43800) / 1440
				);

				if (restofDays === 0) {
					return (changesMsg =
						months === 1
							? `Modified ${months} month ago`
							: `Modified ${months} months ago`);
				}
				if (months === 1) {
					changesMsg =
						months === 1 && restofDays === 1
							? `Modified ${months} month and ${restofDays} day ago`
							: `Modified ${months} month and ${restofDays} days ago`;
				} else {
					changesMsg =
						restofDays === 1
							? `Modified ${months} months and ${restofDays} day ago`
							: `Modified ${months} months and ${restofDays} days ago`;
				}
			} else {
				changesMsg = 'Modified more than 1 year';
			}
			return changesMsg;
		},
		hasFormValue() {
			return !_.isEmpty(this.dataForm);
		},
		loadingSource() {
			return !this.hasFormValue || this.reloaded;
		},
		isSharedForm() {
			return _.get(this, 'dataForm.customers.length', 0) > 1;
		},
		showManageCustomers() {
			return (
				this.dataForm.status !== 'U' &&
				this.editionMode &&
				!this.loadingSource
			);
		},
		showPublish() {
			return (
				this.hasPublishPermission &&
				this.dataForm.status &&
				this.dataForm.id > 0 &&
				this.editionMode
			);
		},
		showUndoChanges() {
			return this.dataForm.status === 'P' && this.editionMode;
		},
		lastPublishedText() {
			if (
				this.dataForm.rowModifiedDate &&
				this.dataForm.status !== 'U' &&
				this.editionMode
			) {
				let result = 'Last Published by ';
				if (this.dataForm.rowModifiedByName) {
					result += this.dataForm.rowModifiedByName + ', ';
				}

				return result;
			}
		},
		requireFieldsAreNotEmpty() {
			const { name, description } = this.dataForm;
			return !!(name && description);
		},
		urlNames() {
			const routeBreadcrumb = this.$route.meta.breadcrumb;
			const storeBreadcrumb = this.$store.getters.breadcrumbs(
				this.$route.path
			);

			if (!_.isEmpty(routeBreadcrumb)) {
				return routeBreadcrumb;
			}

			if (!_.isEmpty(storeBreadcrumb)) {
				return storeBreadcrumb;
			}

			if (this.$route.path.includes('/clients/')) {
				return [
					...this.defaultUrlNamesCustomers,
					{ name: 'Form Designer' }
				];
			}

			return [
				...this.defaultUrlNamesGlobalForms,
				{ name: 'Form Designer' }
			];
		},
		hasPublishPermission() {
			return this.validatePermission('formsPublish.read');
		},
		published() {
			return this.dataForm.status === '';
		},
		disablePublish() {
			return (
				this.published ||
				this.hasFormChanges ||
				this.hasFormBuilderErrors
			);
		}
	},
	methods: {
		...mapActions('form', {
			getFormAction: 'getForm',
			saveFormAction: 'saveForm',
			updateFormAction: 'updateForm',
			undoFormChangesAction: 'undoFormChanges',
			publishFormAction: 'publishFormData'
		}),

		async getFormById(id) {
			await this.getFormAction(id)
				.then(response => {
					this.parseResponse(response);
				})
				.catch(error => {
					this.updateToast({ message: error });
					this.$router.push({ path: '/forms' });
				})
				.finally(() => {
					this.loaded = true;
					this.callTime = new Date();

					setInterval(() => {
						let now = new Date();
						let distance = now.getTime() - this.callTime.getTime();
						let minutes = Math.floor(
							(distance % (1000 * 60 * 60)) / (1000 * 60)
						);
						this.minutesAgo =
							minutes + (this.dataForm.modifiedMinutesDiff || 0);
						return;
					}, 60000);
					this.showRemaining();
				});
		},

		parseResponse(resp) {
			if (resp.formPrintType == 'I' && this.formType === 'Laser') {
				this.$router.push({
					name: 'impact-form-edit-designer',
					params: { id: resp.id }
				});
			}
			if (resp.formPrintType == 'L' && this.formType === 'Impact') {
				this.$router.push({
					name: 'laser-form-edit-designer',
					params: { id: resp.id }
				});
			}
			this.minutesAgo = resp.modifiedMinutesDiff || 0;

			let form = _.clone(resp);

			if (this.id && !this.editionMode) {
				const { description } = form;
				let newDescription = `${description} Copy`;
				if (newDescription.length > 100) {
					newDescription = newDescription.substring(0, 100);
				}
				Object.assign(form, {
					customers: [],
					description: newDescription
				});
			}

			this.dataForm = form;
		},

		saveForm(obj) {
			const self = this;
			self.splitOptionValue = obj.value;
			if (self.editionMode) {
				self.showModal = true;
			}
			!self.editionMode && self.saveAction();
		},

		async saveAction() {
			let statusCode;
			let payload = _.cloneDeep(this.dataForm);
			//api uses customerId instead of dealershipGuid as field
			let customers = [];
			const self = this;
			customers.push.apply(
				customers,
				payload.customers.map(item => {
					return {
						customerId: item.customerId,
						enabled: item.enabled
					};
				})
			);

			payload.customers = customers;

			if (payload.id) {
				payload.message = `New form from a copy of the form with id ${payload.id}`;
				delete payload['id'];
				if (!_.isEmpty(payload.impactInputFields)) {
					payload.impactInputFields.forEach(impact => {
						impact.formsRepositoryId = null;
						impact.formsKeyboardFieldsId = null;
					});
				}
			} else {
				payload.message = 'New form';
			}
			self.reloaded = true;
			let newId = 0;
			if (this.viewData === 'copy') {
				if (!_.isEmpty(payload.impactInputFields)) {
					payload.impactInputFields.forEach(input => {
						input.id = 0;
					});
				}
				if (!_.isEmpty(payload.inputFields)) {
					payload.inputFields.forEach(input => {
						input.id = 0;
					});
				}
			}

			await this.saveFormAction(payload)
				.then(response => {
					statusCode = response.statusCode;
					newId = response.id;
					self.dataForm = _.cloneDeep(response);
					self.originalForm = _.cloneDeep(response);
				})
				.catch()
				.finally(() => {
					self.callTime = new Date();
					self.reloaded = false;
					self.showToastMessage(statusCode);
					if (statusCode === 200) {
						self.saveSuccessully = true;
						//save and close
						if (self.splitOptionValue === 0) {
							self.cancelAction();
						}
						//save
						if (self.splitOptionValue === 1) {
							let name =
								self.formType === 'Laser'
									? 'laser-form-edit-designer'
									: 'impact-form-edit-designer';
							self.$router.push({
								name: name,
								params: { id: newId }
							});
						}
					}
				});
		},

		async updateForm(deletePdf) {
			const self = this;
			let statusCode;
			let payload = {};

			if (deletePdf) {
				payload = _.cloneDeep(self.originalForm);
				payload.pdfData = null;
				payload.laserFormFileName = null;
			} else {
				payload = _.cloneDeep(self.dataForm);

				if (self.isAutoSaved) {
					let message = self.generateMessage();

					payload.message = `form saved automatically at ${message}`;
					self.isAutoSaved = false;
				}

				if (self.resetValue && payload.formPrintType === 'L') {
					payload.formCost = payload.formPrice = payload.formType = null;
				}
			}
			if (payload.impactInputFields.length) {
				payload.impactInputFields.forEach(input => {
					delete input.canBeUpdated;
				});
			}

			self.reloaded = true;

			await self
				.updateFormAction(payload)
				.then(response => {
					statusCode = response.statusCode;
					self.$store.dispatch('forms/reloadForms');

					self.dataForm = _.cloneDeep(response);
					self.originalForm = _.cloneDeep(response);
					//save and close
					if (self.splitOptionValue === 0) {
						self.cancelAction();
					}
					//save
					if (self.splitOptionValue === 1) {
						if (self.expiredTime) self.expiredTime = false;
						self.minutesAgo = response.modifiedMinutesDiff || 0;
						self.dataForm.message = '';
						self.originalForm.message = '';
					}
				})
				.catch()
				.finally(() => {
					self.reloaded = false;
					self.showToastMessage(statusCode);
				});
		},

		showToastMessage(status) {
			const verbiageStatus = status ? 'successfully' : 'unsuccessfully';
			let verbiageAction =
				this.viewData === 'edit'
					? 'updated'
					: this.viewData === 'copy'
					? 'copied'
					: 'added';

			const toastMessage = this.pdfFileDeleted
				? verbiageStatus === 'successfully'
					? `PDF Form deleted ${verbiageStatus}.`
					: `Error - PDF Form deletion failed`
				: `Form ${verbiageStatus} ${verbiageAction}.`;

			const toastObj = {
				status: status ? status : 400,
				message: toastMessage
			};

			this.updateToast(toastObj);
		},

		cancelAction() {
			const route = this.urlNames[this.urlNames.length - 2];
			this.$router.push({
				path: route.data?.path || route.url
			});
		},

		updateToast(val) {
			this.$store.dispatch('toastMessages/show', {
				toastId: 'forms.action',
				statusCode: val.status,
				message: val.message,
				slot: 'default',
				useIcon: true,
				userDismissable: true
			});
		},

		showRemaining(min = 1) {
			this.expiredTime = false;
			let end = new Date(new Date().getTime() + min * 60000);
			const timer = setInterval(() => {
				let now = new Date();

				let distance = end.getTime() - now.getTime();

				if (distance < 0) {
					clearInterval(timer);
					this.expiredTime = true;
					return;
				}
			}, 60000);
		},
		generateMessage() {
			const today = new Date();
			const date = `${today.getFullYear()}-${today.getMonth()}-${today.getDate()}`;
			const time = `${today.getHours()}:${today.getMinutes()}:${today.getSeconds()}`;
			return date + ' ' + time;
		},
		async undoFormChanges() {
			const self = this;
			let statusCode;

			await this.undoFormChangesAction(self.dataForm.id)
				.then(response => {
					statusCode = response.statusCode;
					self.parseResponse(response);
				})
				.catch(error => {
					self.updateToast({ message: error });
				})
				.finally(() => {
					const verbiage = statusCode
						? 'successfully'
						: 'unsuccessfully';

					const toastObj = {
						status: statusCode,
						message: `Form ${verbiage} undid changes.`
					};

					self.updateToast(toastObj);
				});
			self.showUndoModal = false;
		},
		async publishForm() {
			if (this.hasPublishPermission) {
				await this.publishFormAction(this.dataForm.id).then(resp => {
					if (!_.isEmpty(resp)) {
						Object.assign(this.dataForm, {
							status: '',
							rowModifiedDate: resp.rowModifiedDate
						});
						this.minutesAgo = 0;
					}
				});
			}
		},
		showModalUndoChanges() {
			this.showUndoModal = true;
		},
		cancel() {
			this.showUndoModal = false;
		},
		computeExtraHeightInfinityScroll() {
			const offsetHeightformIsFixedFooter = 65;
			let extra = Math.ceil(
				_.get(this, '$refs.contentPageHeading.offsetHeight', 0)
			);
			extra += 24 + 24; //content-page__heading margin

			if (this.isSharedForm) {
				extra += Math.ceil(
					_.get(this, '$refs.blockContainer.$el.offsetHeight', 0)
				);
				extra += 24; // 24; //block-notify-container margin
			}

			if (!this.displayFooter) {
				let offsetHeightFormFooter = Math.ceil(
					_.get(this, '$refs.mainContentFooter.offsetHeight', 0)
				);
				extra +=
					offsetHeightFormFooter == 33
						? offsetHeightFormFooter + offsetHeightformIsFixedFooter
						: offsetHeightFormFooter + 33;
			}

			if (this.customerParam?.id) {
				const customerNavIndex = 0;
				let offsetHeightCustomerNav = Math.ceil(
					_.get(
						this,
						`$el.children[${customerNavIndex}].offsetHeight`,
						0
					)
				);
				extra += offsetHeightCustomerNav;
			}
			this.extraHeightInfinityScroll = extra - 5; //extra margin;
		},
		handleScollEnd(value) {
			this.scrollEnd = value;
			if (this.scrollEnd) {
				this.$nextTick(() => {
					this.computeExtraHeightInfinityScroll();
				});
			}
			this.displayFooter = !value;
		},
		setCalculateDivMaxHeight(val) {
			this.maxHeightInfinityScroll = val.maxHeightInfinityScroll;
			this.mainScrollHeight = val.scrollHeight;
		}
	},
	async beforeRouteLeave(to, from, next) {
		const routePages = [
			'impact-form-edit-designer',
			'laser-form-edit-designer'
		];
		let newBreadcrumb = [];

		if (
			(to.name === 'form-history' ||
				to.name === 'customer-form-history') &&
			routePages.includes(from.name)
		) {
			let actualBreadcrumb =
				from.meta && from.meta.breadcrumb
					? [...from.meta.breadcrumb]
					: this.$store.getters.breadcrumbs(to.fullPath);

			actualBreadcrumb.find(item => {
				if (item.name === 'Form Designer') {
					item.url = from.fullPath;
				}
			});

			actualBreadcrumb.push({ name: 'History' });

			to.meta.breadcrumb = actualBreadcrumb;
		}

		if (to.name === 'customer-forms') {
			const actualBreadcrumb =
				from.meta && from.meta.breadcrumb
					? [...from.meta.breadcrumb]
					: this.$store.getters.breadcrumbs(to.fullPath);

			newBreadcrumb = actualBreadcrumb
				.filter(
					obj =>
						obj.name !== 'Form Designer' && obj.name !== 'History'
				)
				.map(obj => {
					if (obj.name === 'Forms') {
						delete obj.url;
					}
					return obj;
				});

			if (_.isEmpty(newBreadcrumb)) {
				to.meta.breadcrumb = this.defaultUrlNamesCustomers.map(obj => {
					if (obj.name === 'Forms') {
						delete obj.url;
					}
					return obj;
				});
			} else {
				to.meta.breadcrumb = newBreadcrumb;
			}
		}

		if (to.name === 'code-manager' && routePages.includes(from.name)) {
			let actualBreadcrumb =
				from.meta && from.meta.breadcrumb
					? [...from.meta.breadcrumb]
					: this.$store.getters.breadcrumbs(to.fullPath);

			newBreadcrumb = actualBreadcrumb
				.filter(obj => obj.name !== 'Form Designer')
				.map(item => {
					if (item.name === 'Code Manager') {
						return { name: item.name };
					}
					return item;
				});

			to.meta.breadcrumb = newBreadcrumb;
		}
		const obj = { path: to.fullPath, breadcrumb: newBreadcrumb };
		this.$store.commit('setBreadCrumbs', obj);

		if (this.hasFormChanges) {
			this.displayConfirmationModal = true;

			const response = await this.$refs.confirmationDialogue.confirm();
			if (response) {
				this.dataForm = {};
				this.splitOptionValue = null;
				next();
			} else {
				next(false);
			}
		} else {
			next();
		}
	},
	watch: {
		maxHeightInfinityScroll: {
			deep: true,
			handler(val) {
				if (val && !this.displayFooter && !this.scrollEnd) {
					this.displayFooter = val < this.mainScrollHeight;
					this.computeExtraHeightInfinityScroll();
				}
			}
		},
		dataForm: {
			deep: true,
			handler(val) {
				if (_.isEmpty(this.originalForm) && this.editionMode) {
					this.originalForm = _.cloneDeep(val);
				}
				const customerId = this.$route.params.customerId;
				if (customerId) {
					let hasCurrentCustomer = false;
					if (val.customers) {
						hasCurrentCustomer = val.customers.some(
							c => c.customerId === customerId
						);
					}
					if (!hasCurrentCustomer && val.customers) {
						val.customers.push({
							assigned: false,
							customerId: customerId,
							enabled: false
						});
					}
				}
			}
		},
		expiredTime: {
			handler(val) {
				if (
					val &&
					this.$cookies.get('formAutoSave') === 'true' &&
					this.hasFormChanges &&
					this.editionMode
				) {
					this.isAutoSaved = true;
					this.splitOptionValue = 1;
					this.updateForm();
				}
				if (val) {
					this.showRemaining();
				}
			}
		},
		hasFormValue: {
			handler(val) {
				if (val) {
					this.$nextTick(() => {
						this.computeExtraHeightInfinityScroll();
					});
				}
			}
		},
		currentCustomers: {
			handler(arrayCustomers) {
				if (
					!_.isEmpty(arrayCustomers) &&
					!_.isEqual(arrayCustomers, this.dataForm.customers)
				) {
					this.dataForm.customers = arrayCustomers;
					this.originalForm.customers = arrayCustomers;
					this.$store.dispatch('forms/currentCustomers', []);
				}
			}
		}
	}
};
